import React, { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArchitectureNotes from '../components/architecture/ArchitectureNotes';
import EntityDetailsPanel from '../components/architecture/EntityDetailsPanel';
import EntityMap from '../components/architecture/EntityMap';
import { ChildKey, EntityId, INITIAL_SELECTION, Selection } from '../components/architecture/entityModel';

// Static content: hoisted so it is created once, not per selection change.
const pageHeader = (
  <Box>
    <Typography component="h1" sx={{ fontSize: 32, fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
      Data architecture
    </Typography>
    <Typography sx={{ mt: 0.75, color: 'text.secondary', fontSize: 14, maxWidth: 720 }}>
      How configuration entities relate to each other. Select any entity in the map to see what it contains and what it connects to.
    </Typography>
  </Box>
);
const notes = <ArchitectureNotes />;

const DataArchitecturePage: React.FC = () => {
  const [selection, setSelection] = useState<Selection>(INITIAL_SELECTION);
  const select = useCallback((id: EntityId, focus?: ChildKey) => setSelection({ id, focus: focus ?? null }), []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, maxWidth: 1480, width: '100%' }}>
      {pageHeader}
      <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <EntityMap selection={selection} onSelect={select} />
        <EntityDetailsPanel selection={selection} onSelect={select} />
      </Box>
      {notes}
    </Box>
  );
};

export default DataArchitecturePage;
